import React, { useEffect, useState, useRef } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from 'reactstrap';
import { api } from '../../../services/api';

interface ModalQRCodeViewerProps {
  isOpen: boolean;
  onClose: () => void;
  dependentId: number;
}

export function ModalQRCodeViewer({
  isOpen,
  onClose,
  dependentId,
}: ModalQRCodeViewerProps): React.JSX.Element {
  const [loading, setLoading] = useState(true);
  const [qrCodeUrl, setQrCodeUrl] = useState<string | null>(null);
  const printRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen && dependentId) {
      setLoading(true);
      setQrCodeUrl(null);

      api
        .get(`/dependent/${dependentId}/qrcode`)
        .then((response) => {
          const base64 = response.data?.base64;
          console.log(response, 'teste');

          // Se for base64 puro (sem o prefixo), adicione o prefixo:
          const isFullBase64 = base64.startsWith('data:image');
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          const imageUrl = isFullBase64 ? base64 : `data:image/png;base64,${base64}`;

          setQrCodeUrl(imageUrl);
        })
        .catch((error) => {
          console.error('Erro ao carregar QR Code:', error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [isOpen, dependentId]);

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handlePrint = () => {
    if (!printRef.current) return;

    const printContents = printRef.current.innerHTML;
    const newWin = window.open('', '', 'width=600,height=600');
    if (newWin) {
      newWin.document.write(`
        <html>
          <head>
            <title>QR-code</title>
            <style>
              body { text-align: center; margin: 0; padding: 40px; }
              img { max-width: 100%; height: auto; }
            </style>
          </head>
          <body>${printContents}</body>
        </html>
      `);
      newWin.document.close();

      newWin.onload = () => {
        const img = newWin.document.querySelector('img');
        if (img && !img.complete) {
          img.onload = () => {
            newWin.focus();
            newWin.print();
            newWin.close();
          };
        } else {
          newWin.focus();
          newWin.print();
          newWin.close();
        }
      };
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="md" centered>
      <ModalHeader toggle={onClose}>QR Code do Dependente</ModalHeader>
      <ModalBody className="text-center">
        {loading ? (
          <Spinner />
        ) : qrCodeUrl ? (
          <div ref={printRef}>
            <img
              src={qrCodeUrl}
              alt="QR Code"
              width={400}
              height={400}
              style={{ marginBottom: '20px' }}
            />
          </div>
        ) : (
          <p>QR Code não disponível.</p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handlePrint} disabled={!qrCodeUrl}>
          Imprimir QR Code
        </Button>
        <Button color="secondary" onClick={onClose}>
          Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
}
